import React, { Dispatch } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

type Props = {
  options: OptionType[];
  label?: string;
  placeholder?: string;
  value: OptionType;
  setValue: Dispatch<OptionType>;
  size?: 'small' | 'medium';
};

export default function AutocompleteSelect({
  options,
  label = '',
  placeholder,
  value,
  setValue,
  size = "medium",
}: Props) {
  return (
    <Autocomplete
      id={`autocomplete__select_${label}`}
      sx={{ width: 300 }}
      options={options}
      autoHighlight
      value={value}
      onChange={(e, option) =>
        option !== null ? setValue(option) : setValue({ label: '', value: '' })
      }
      getOptionLabel={(option: OptionType) => option.label ?? ''}
      //   renderOption={(props, option) => <span>{option.label}</span>}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          inputProps={{
            ...params.inputProps,
            value:value?.label
          }}
          size={size}
        />
      )}
    />
  );
}

export interface OptionType {
  value: string;
  label: string;
}
